<template>
  <div
    class="xl:px-32 lg:px-20 md:px-14 px-10 bg-white pt-5 pb-5 sm:flex-col sm:justify-center"
  >
    <div class="flex flex-wrap lg:justify-center h-auto">
      <div
        class="m-auto border border-[#fff] shadow-xl p-10 rounded-lg md:w-[60%] w-full"
      >
        <h1
          class="text-center text-[#006] md:text-3xl sm:text-2xl text-xl font-bold pb-5"
        >
          ¿Tienes alguna duda?
        </h1>
        <p class="text-justify text-black md:text-lg sm:text-base text-sm">
          Si tienes alguna duda, puedes contactarte a través de las siguientes
          plataformas:
        </p>

        <div class="flex items-center px-5 pb-2">
          <img
            src="../../assets/contactanos/bxl-instagram.svg"
            class="w-[45px] p-2 border border-[#231f20] bg-[#fff] rounded-full m-2"
          />
          <a
            target="_blank"
            href="https://www.instagram.com/procesa_aiche/?hl=es0"
            class="md:text-lg sm:text-base text-sm text-black"
            >procesa_aiche</a
          >
        </div>

        <div class="flex items-center px-5 pb-2">
          <img
            src="../../assets/contactanos/bxl-gmail.svg"
            class="w-[45px] p-2 border border-[#231f20] bg-[#fff] rounded-full m-2"
          />

          <a
            class="text-[15px] md:text-lg sm:text-base text-sm text-black"
            href="mailto:procesa@utec.edu.pe"
            >procesa@utec.edu.pe</a
          >
        </div>

        <div class="flex items-center px-5 pb-2">
          <img
            src="../../assets/contactanos/bxl-whatsapp.svg"
            class="w-[45px] p-2 border border-[#231f20] bg-[#fff] rounded-full m-2"
          />

          <p class="text-[14px] md:text-lg sm:text-base text-sm text-black">
            +51 956572242 / +51 956157244
          </p>
        </div>
      </div>
      <div
        class="sm:flex xl:pt-0 pt-10 pl-2 md:w-2/6 m-auto md:visible invisible w-0"
      >
        <img
          class="sm:ml-auto sm:mr-auto sm:pt-8 md:pt-0"
          src="../../assets/contactanos/circular-logo-aiche.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
